module.exports = __webpack_public_path__ + "img/Weapon_293.15a4c0ac.png";